import {BrowserRouter as Router, HashRouter} from 'react-router-dom';
import Layout from './Shared/Components/Layout/Layout'
import SpaceBackground from "./Shared/SpaceBackground";

const App = () => <HashRouter> <Layout /></HashRouter>

export default App;
